import { useTheme } from '@material-ui/core';
import { ChatTray } from '@src/types/chats';
import { useIntl } from 'react-intl';
import Typography from '@src/components/UI/Typography';

export type ChatNewContactIndicatorProps = {
  chat: ChatTray;
};

const ChatNewContactIndicator: React.FC<ChatNewContactIndicatorProps> = ({
  chat: { contact },
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  if (!contact?.isNewContact) return null;

  return (
    <Typography
      variant="body-xs"
      fontWeight="semibold"
      whiteSpace="nowrap"
      // Same red as the unread-messages count it sits next to.
      style={{ color: theme.b2chatred['500'], lineHeight: 1 }}
      data-testid="chat-new-contact-indicator"
    >
      {formatMessage({ id: 'Chat.newContactIndicator' })}
    </Typography>
  );
};

export default ChatNewContactIndicator;
